export const EventLogStatus = {
    Success: "success",
    Warning: "warning",
    Error: "error",
    Info: "info",
} as const;

export const ProductReferenceCalculationSource = {
    CurrentProductMiddleware: "current-product-middleware",
    CurrentProductMiddlewareFallback: "current-product-middleware:fallback",
    SubFamiliesConfigApiMapping: "sub-families-config:api-mapping",
    SubFamiliesConfigUserInput: "sub-families-config:user-input",
    PowerSupplyDimmingType: "power-supply-dimming-type",
} as const;
